import { http } from './http'
import { Pagination } from './map'
import {
  Order,
  Orders,
  RefundOrder,
  RefundOrderPayload,
} from '../../common/models'
import {
  IGiftedToPayload,
  Payments,
  RefundBagTicket,
  RefundTicketPayload,
  UserWithOrdersDto,
} from '../../common/models/orders'

export type OrderPaginationParams = {
  page?: number
  size?: number
  sortBy?: string
  sortDirection?: 'ASC' | 'DESC'
  startDate?: number
  endDate?: number
  email?: string | null
  displayableOrderNumber?: string | null
  barcode?: string | null
  buyer?: string | null
  showFailedOrders?: boolean
}

export const getAllOrders = (params?: OrderPaginationParams) =>
  http.get<Pagination<Orders>>('/operations/orders', {
    params,
  })

export const getOrder = (id: string) =>
  http.get<Order>(`/operations/orders/${id}`)

export const payInstallment = (orderId: string, installmentId: string) =>
  http.put<Payments>(
    `/operations/orders/${orderId}/installment/${installmentId}/pay`,
  )

export const updateGift = (
  id: string,
  participationId: string,
  data: IGiftedToPayload,
) =>
  http.put(
    `/operations/orders/${id}/participation/${participationId}/gift`,
    data,
  )

export const getRefundOrder = (id: string) =>
  http.get<RefundOrder>(`/operations/orders/${id}/refund`)

export const updateRefundOrder = (id: string, data: RefundOrderPayload) =>
  http.put(`/operations/orders/${id}/refund`, data)

export const getRefundOrderTicket = (id: string, userBagTicketId: string) =>
  http.get<RefundBagTicket>(
    `/operations/orders/${id}/ticket/${userBagTicketId}/refund`,
  )

export const updateRefundOrderTicket = (
  id: string,
  userBagTicketId: string,
  data: RefundTicketPayload,
) => http.put(`/operations/orders/${id}/ticket/${userBagTicketId}/refund`, data)

export const patchTicketOwner = (
  id: string,
  data: { phone: string; name: string },
) =>
  http.patch(`/operations/ticket/user-participation-ticket/${id}/phone`, data)

export const freeCheckin = (
  id: string,
  participationId: string,
  checkin: string,
) =>
  http.put(
    `/operations/orders/${id}/participation/${participationId}/free-checkin${checkin}`,
  )

/**
 * Cancels a DONE check-in. The backend soft-deletes it, creates a fresh one and
 * emails the ticket owner. Rejected when the check-in has been topped up.
 */
export const cancelCheckin = (checkinId: string) =>
  http.put(`/operations/ticket/checkin/${checkinId}/cancel`)

/** Moves an IN_PROGRESS check-in back to NOT_STARTED, discarding submitted details. */
export const resetCheckinStatus = (checkinId: string) =>
  http.put(`/operations/ticket/checkin/${checkinId}/reset`)

export const backstageIntegration = (orderId: string) =>
  http.post(`/operations/orders/${orderId}/start-backstage-integration`)

export const syncWristband = (orderId: string, participationId: string) =>
  http.put(
    `/operations/orders/${orderId}/participation/${participationId}/sync-wristband`,
  )

export const alcatrazEnroll = (orderId: string, participationId: string) =>
  http.post(
    `/operations/orders/${orderId}/participation/${participationId}/alcatraz-enroll`,
  )

export const getUsersOrders = (params?: OrderPaginationParams) =>
  http.get<Pagination<UserWithOrdersDto>>('/operations/orders/users', {
    params,
  })

export const getOrderInvoice = (id: string) =>
  http.get<string>(`/operations/orders/${id}/invoice`)

export const getTicketsInBagReport = (editionId: string) =>
  http.get<string>(`/operations/reports/tickets-in-bag/${editionId}`, {
    responseType: 'text',
  })
